import React, { useEffect, useState } from "react";

const findMatches = (string, searchVal) => string.toLowerCase().includes(searchVal.toLowerCase());

const useListbox = (options = [], onSearch, onClose, scrollFetch) => {
  const [filteredOptions, setFilteredOptions] = useState(options);
  const [isClientFiltered, setIsClientFiltered] = useState(false);
  const [initialOptionsLength, setInitialOptionsLength] = useState(0);
  const isGrouped = options.length && options[0].items;
  const flattenedOptions = isGrouped ? options.map(option => option.items).flat() : options;
  const filteredCount = isGrouped ? filteredOptions.map(option => option.items).flat().length : filteredOptions.length;
  const isClientsideSearch = initialOptionsLength > 10 && !onSearch && !scrollFetch;
  const isServersideSearch = initialOptionsLength > 10 && !!onSearch;
  const isSearchable = isClientsideSearch || isServersideSearch;

  useEffect(() => {
    if (flattenedOptions.length > 0 && initialOptionsLength === 0) {
      setInitialOptionsLength(flattenedOptions.length);
    }
  }, [flattenedOptions.length, initialOptionsLength]);

  useEffect(() => {
    if (!isClientFiltered) {
      setFilteredOptions(options);
    }
  }, [options, isClientFiltered]);

  const handleSearch = val => {
    if (isServersideSearch) {
      setIsClientFiltered(false);
      onSearch(val);
    } else if (val === "") {
      setIsClientFiltered(false);
      setFilteredOptions(options);
    } else {
      const filtered = isGrouped
        ? options.map(group => ({
            label: group.label,
            items: group.items.filter(option => findMatches(option.label, val)),
          }))
        : options.filter(option => findMatches(option.label, val));

      setIsClientFiltered(true);
      setFilteredOptions(filtered);
    }
  };

  const resetSearch = () => {
    if (isServersideSearch) {
      onSearch("");
    } else {
      setFilteredOptions(options);
    }
  };

  const handleClose = () => {
    resetSearch();
    onClose();
  };

  return {
    filteredOptions,
    flattenedOptions,
    handleSearch,
    handleClose,
    filteredCount,
    isGrouped,
    isSearchable,
  };
};

export default useListbox;
